import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { QrCode, CheckCircle, EnvelopeSimple, CircleNotch } from "@phosphor-icons/react";
import { useLang } from "../context/LangContext";
import { useAuth } from "../context/AuthContext";
import { Footer } from "../components/Footer";
import api from "../lib/api";

export default function Grazie() {
  const { t, lang, toggle } = useLang();
  const { user } = useAuth();
  const navigate = useNavigate();
  const g = t.thanks;
  const [activated, setActivated] = useState(false);
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (!user) return;
    let tries = 0;
    const iv = setInterval(async () => {
      tries += 1;
      try {
        const { data } = await api.get("/me/plan");
        if (data.subscription_active || data.archive_package) {
          clearInterval(iv);
          setActivated(true);
          setTimeout(() => navigate("/dashboard"), 1800);
        }
      } catch (e) {}
      if (tries >= 20) {
        clearInterval(iv);
        setTimedOut(true);
      }
    }, 3000);
    return () => clearInterval(iv);
  }, [user, navigate]);

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="thanks-page">
      <header className="border-b border-slate-200">
        <div className="mx-auto max-w-3xl px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="thanks-logo">
            <div className="flex h-8 w-8 items-center justify-center bg-[#0A0F1A] rounded-[4px]"><QrCode size={18} weight="bold" className="text-white" /></div>
            <span className="font-display font-bold text-[17px] tracking-tight">Certifico<span className="text-emerald-500">QR</span></span>
          </Link>
          <button onClick={toggle} className="font-mono-tech text-xs font-semibold border border-slate-300 rounded-[4px] px-2 py-1" data-testid="thanks-lang-toggle">{lang.toUpperCase()}</button>
        </div>
      </header>

      <main className="flex-1 mx-auto w-full max-w-2xl px-6 py-20 text-center">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}>
          <CheckCircle size={64} weight="fill" className="mx-auto text-emerald-500" />
          <h1 className="mt-6 font-display font-bold text-3xl sm:text-4xl tracking-tight text-[#0F172A]" data-testid="thanks-title">{g.title}</h1>
          <p className="mt-4 text-base leading-relaxed text-slate-600">{g.subtitle}</p>

          {user ? (
            <div className="mt-8" data-testid="thanks-auth-status">
              {activated ? (
                <p className="inline-flex items-center gap-2 text-emerald-600 font-semibold" data-testid="thanks-activated">
                  <CheckCircle size={18} weight="fill" /> {g.activated}
                </p>
              ) : timedOut ? (
                <p className="text-sm text-slate-500" data-testid="thanks-timeout">{g.timeout}</p>
              ) : (
                <p className="inline-flex items-center gap-2 text-slate-500" data-testid="thanks-checking">
                  <CircleNotch size={18} className="animate-spin" /> {g.checking}
                </p>
              )}
              <div className="mt-6">
                <Link to="/dashboard" className="inline-flex justify-center rounded-full bg-emerald-500 px-7 py-3.5 text-sm font-semibold text-[#04170F] hover:bg-emerald-400 transition-colors" data-testid="thanks-dashboard">{g.goDashboard}</Link>
              </div>
            </div>
          ) : (
            <>
              <div className="mt-8 flex items-start gap-3 rounded-md border border-emerald-200 bg-emerald-50 p-5 text-left">
                <EnvelopeSimple size={20} className="text-emerald-600 shrink-0 mt-0.5" />
                <p className="text-sm leading-relaxed text-emerald-900">{g.emailNote}</p>
              </div>
              <div className="mt-10 flex flex-col sm:flex-row justify-center gap-3">
                <Link to="/register" className="inline-flex justify-center rounded-full bg-emerald-500 px-7 py-3.5 text-sm font-semibold text-[#04170F] hover:bg-emerald-400 transition-colors" data-testid="thanks-register">{g.ctaRegister}</Link>
                <Link to="/login" className="inline-flex justify-center rounded-full border border-slate-300 px-7 py-3.5 text-sm font-semibold text-slate-700 hover:border-emerald-500 hover:text-emerald-600 transition-colors" data-testid="thanks-login">{g.ctaLogin}</Link>
              </div>
            </>
          )}
        </motion.div>
      </main>

      <Footer />
    </div>
  );
}
